import React from 'react'

import AccessProcess, { Step } from 'components/AccessProcess'
import { helpHost } from 'constants/env'

import icon1 from './images/icon1.png'
import icon2 from './images/icon2.png'
import icon3 from './images/icon3.png'
import icon4 from './images/icon4.png'
import icon5 from './images/icon5.png'

export default function Process() {
  return (
    <AccessProcess name="process" title="接入流程" grey>
      <Step icon={icon1} url="/cooperations#apply" target="_self">
        提交合作意向信息
      </Step>
      <Step icon={icon2} url={helpHost + '/os/niulink.html'}>
        安装镜像
      </Step>
      <Step icon={icon3} url={helpHost + '/mp/bind.html'}>
        小程序提交机器信息
      </Step>
      <Step icon={icon4}>
        平台验收和分发资源测试
      </Step>
      <Step icon={icon5}>
        正式共享资源获取收益
      </Step>
    </AccessProcess>
  )
}
